export const mimeTypes: {
    mimeTyp: string;
    fileExtension: string;
    description: string;
}[] = [
    {
        mimeTyp: 'application/acad',
        fileExtension: '*.dwg',
        description: 'AutoCAD-Datei (nach NCSA)',
    },
    {
        mimeTyp: 'application/applefile',
        fileExtension: '&nbsp;',
        description: 'AppleFile-Datei',
    },
    {
        mimeTyp: 'application/astound',
        fileExtension: '*.asd *.asn',
        description: 'Astound-Datei',
    },
    {
        mimeTyp: 'application/dsptype',
        fileExtension: '*.tsp',
        description: 'TSP-Datei',
    },
    {
        mimeTyp: 'application/dxf',
        fileExtension: '*.dxf',
        description: 'AutoCAD-Datei (nach CERN)',
    },
    {
        mimeTyp: 'application/force-download',
        fileExtension: '*.reg',
        description: 'RegistrierungsDatei',
    },
    {
        mimeTyp: 'application/futuresplash',
        fileExtension: '*.spl',
        description: 'Flash Futuresplash-Datei',
    },
    {
        mimeTyp: 'application/gzip',
        fileExtension: '*.gz',
        description: 'GNU Zip-Datei',
    },
    {
        mimeTyp: 'application/javascript',
        fileExtension: '*.js',
        description: 'serverseitige JavaScript-Datei',
    },
    {
        mimeTyp: 'application/json',
        fileExtension: '*.json',
        description: 'enthält einen String in JavaScript-Objekt-Notation',
    },
    {
        mimeTyp: 'application/listenup',
        fileExtension: '*.ptlk',
        description: 'Listenup-Datei',
    },
    {
        mimeTyp: 'application/mac-binhex40',
        fileExtension: '*.hqx',
        description: 'Macintosh BinärDatei',
    },
    {
        mimeTyp: 'application/mbedlet',
        fileExtension: '*.mbd',
        description: 'Mbedlet-Datei',
    },
    {
        mimeTyp: 'application/mif',
        fileExtension: '*.mif',
        description: 'FrameMaker Interchange Format Datei',
    },
    {
        mimeTyp: 'application/msexcel',
        fileExtension: '*.xls *.xla',
        description: 'Microsoft Excel Datei',
    },
    {
        mimeTyp: 'application/mshelp',
        fileExtension: '*.hlp *.chm',
        description: 'Microsoft Windows Hilfe Datei',
    },
    {
        mimeTyp: 'application/mspowerpoint',
        fileExtension: '*.ppt *.ppz *.pps *.pot',
        description: 'Microsoft Powerpoint Datei',
    },
    {
        mimeTyp: 'application/msword',
        fileExtension: '*.doc *.dot',
        description: 'Microsoft Word Datei',
    },
    {
        mimeTyp: 'application/octet-stream',
        fileExtension: '*.bin *.file *.com *.class *.ini',
        description: 'Nicht näher spezifizierte Daten, z.B. ausführbare Datei',
    },
    {
        mimeTyp: 'application/oda',
        fileExtension: '*.oda',
        description: 'Oda-Datei',
    },
    {
        mimeTyp: 'application/pdf',
        fileExtension: '*.pdf',
        description: 'PDF-Datei',
    },
    {
        mimeTyp: 'application/postscript',
        fileExtension: '*.ai *.eps *.ps',
        description: 'PostScript-Datei',
    },
    {
        mimeTyp: 'application/rtc',
        fileExtension: '*.rtc',
        description: 'RTC-Datei',
    },
    {
        mimeTyp: 'application/rtf',
        fileExtension: '*.rtf',
        description: 'RTF-Datei',
    },
    {
        mimeTyp: 'application/studiom',
        fileExtension: '*.smp',
        description: 'Studiom-Datei',
    },
    {
        mimeTyp: 'application/toolbook',
        fileExtension: '*.tbk',
        description: 'Toolbook-Datei',
    },
    {
        mimeTyp: 'application/vocaltec-media-desc',
        fileExtension: '*.vmd',
        description: 'Vocaltec Mediadesc-Datei',
    },
    {
        mimeTyp: 'application/vocaltec-media-file',
        fileExtension: '*.vmf',
        description: 'Vocaltec Media-Datei',
    },
    {
        mimeTyp: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        fileExtension: '*.xlsx',
        description: 'Excel (OpenOffice Calc)',
    },
    {
        mimeTyp: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        fileExtension: '*.docx',
        description: 'Word (OpenOffice Writer)',
    },
    {
        mimeTyp: 'application/xhtml+xml',
        fileExtension: '*.htm *.html *.shtml *.xhtml',
        description: 'XHTML-Datei',
    },
    {
        mimeTyp: 'application/xml',
        fileExtension: '*.xml',
        description: 'XML-Datei',
    },
    {
        mimeTyp: 'application/x-bcpio',
        fileExtension: '*.bcpio',
        description: 'BCPIO-Datei',
    },
    {
        mimeTyp: 'application/x-compress',
        fileExtension: '*.z',
        description: 'zlib-komprimierte Datei',
    },
    {
        mimeTyp: 'application/x-cpio',
        fileExtension: '*.cpio',
        description: 'CPIO-Datei',
    },
    {
        mimeTyp: 'application/x-csh',
        fileExtension: '*.csh',
        description: 'C-Shellscript-Datei',
    },
    {
        mimeTyp: 'application/x-director',
        fileExtension: '*.dcr *.dir *.dxr',
        description: 'Macromedia Director-Datei',
    },
    {
        mimeTyp: 'application/x-dvi',
        fileExtension: '*.dvi',
        description: 'DVI-Datei',
    },
    {
        mimeTyp: 'application/x-envoy',
        fileExtension: '*.evy',
        description: 'Envoy-Datei',
    },
    {
        mimeTyp: 'application/x-gtar',
        fileExtension: '*.gtar',
        description: 'GNU tar-ArchivDatei',
    },
    {
        mimeTyp: 'application/x-hdf',
        fileExtension: '*.hdf',
        description: 'HDF-Datei',
    },
    {
        mimeTyp: 'application/x-httpd-php',
        fileExtension: '*.php *.phtml',
        description: 'PHP-Datei',
    },
    {
        mimeTyp: 'application/x-latex',
        fileExtension: '*.latex',
        description: 'LaTeX-QuellDatei',
    },
    {
        mimeTyp: 'application/x-macbinary',
        fileExtension: '*.bin',
        description: 'Macintosh BinärDatei',
    },
    {
        mimeTyp: 'application/x-mif',
        fileExtension: '*.mif',
        description: 'FrameMaker Interchange Format Datei',
    },
    {
        mimeTyp: 'application/x-netcdf',
        fileExtension: '*.nc *.cdf',
        description: 'Unidata CDF-Datei',
    },
    {
        mimeTyp: 'application/x-nschat',
        fileExtension: '*.nsc',
        description: 'NS Chat-Datei',
    },
    {
        mimeTyp: 'application/x-sh',
        fileExtension: '*.sh',
        description: 'Bourne Shellscript-Datei',
    },
    {
        mimeTyp: 'application/x-shar',
        fileExtension: '*.shar',
        description: 'Shell-ArchivDatei',
    },
    {
        mimeTyp: 'application/x-shockwave-flash',
        fileExtension: '*.swf *.cab',
        description: 'Flash Shockwave-Datei',
    },
    {
        mimeTyp: 'application/x-sprite',
        fileExtension: '*.spr *.sprite',
        description: 'Sprite-Datei',
    },
    {
        mimeTyp: 'application/x-stuffit',
        fileExtension: '*.sit',
        description: 'Stuffit-Datei',
    },
    {
        mimeTyp: 'application/x-supercard',
        fileExtension: '*.sca',
        description: 'Supercard-Datei',
    },
    {
        mimeTyp: 'application/x-sv4cpio',
        fileExtension: '*.sv4cpio',
        description: 'CPIO-Datei',
    },
    {
        mimeTyp: 'application/x-sv4crc',
        fileExtension: '*.sv4crc',
        description: 'CPIO-Datei mit CRC',
    },
    {
        mimeTyp: 'application/x-tar',
        fileExtension: '*.tar',
        description: 'tar-ArchivDatei',
    },
    {
        mimeTyp: 'application/x-tcl',
        fileExtension: '*.tcl',
        description: 'TCL ScriptDatei',
    },
    {
        mimeTyp: 'application/x-tex',
        fileExtension: '*.tex',
        description: 'TeX-Datei',
    },
    {
        mimeTyp: 'application/x-texinfo',
        fileExtension: '*.texinfo *.texi',
        description: 'Texinfo-Datei',
    },
    {
        mimeTyp: 'application/x-troff',
        fileExtension: '*.t *.tr *.roff',
        description: 'TROFF-Datei (Unix)',
    },
    {
        mimeTyp: 'application/x-troff-man',
        fileExtension: '*.man *.troff',
        description: 'TROFF-Datei mit MAN-Makros (Unix)',
    },
    {
        mimeTyp: 'application/x-troff-me',
        fileExtension: '*.me *.troff',
        description: 'TROFF-Datei mit ME-Makros (Unix)',
    },
    {
        mimeTyp: 'application/x-troff-ms',
        fileExtension: '*.me *.troff',
        description: 'TROFF-Datei mit MS-Makros (Unix)',
    },
    {
        mimeTyp: 'application/x-ustar',
        fileExtension: '*.ustar',
        description: 'tar-ArchivDatei (Posix)',
    },
    {
        mimeTyp: 'application/x-wais-source',
        fileExtension: '*.src',
        description: 'WAIS QuellDatei',
    },
    {
        mimeTyp: 'application/x-www-form-urlencoded',
        fileExtension: '&nbsp;',
        description: 'HTML-Formulardaten an CGI',
    },
    {
        mimeTyp: 'application/zip',
        fileExtension: '*.zip',
        description: 'ZIP-ArchivDatei',
    },
    {
        mimeTyp: 'audio/basic',
        fileExtension: '*.au *.snd',
        description: 'Sound-Datei',
    },
    {
        mimeTyp: 'audio/echospeech',
        fileExtension: '*.es',
        description: 'Echospeed-Datei',
    },
    {
        mimeTyp: 'audio/mpeg',
        fileExtension: '*.mp3',
        description: 'MP3-Datei',
    },
    {
        mimeTyp: 'audio/mp4',
        fileExtension: '*.mp4',
        description: 'MP4-Datei',
    },
    {
        mimeTyp: 'audio/ogg',
        fileExtension: '*.ogg',
        description: 'OGG-Datei',
    },
    {
        mimeTyp: 'audio/tsplayer',
        fileExtension: '*.tsi',
        description: 'TS-Player-Datei',
    },
    {
        mimeTyp: 'audio/voxware',
        fileExtension: '*.vox',
        description: 'Vox-Datei',
    },
    {
        mimeTyp: 'audio/wav',
        fileExtension: '*.wav',
        description: 'WAV-Datei',
    },
    {
        mimeTyp: 'audio/x-aiff',
        fileExtension: '*.aif *.aiff *.aifc',
        description: 'AIFF-Sound-Datei',
    },
    {
        mimeTyp: 'audio/x-dspeeh',
        fileExtension: '*.dus *.cht',
        description: 'SprachDatei',
    },
    {
        mimeTyp: 'audio/x-midi',
        fileExtension: '*.mid *.midi',
        description: 'MIDI-Datei',
    },
    {
        mimeTyp: 'audio/x-mpeg',
        fileExtension: '*.mp2',
        description: 'MPEG-AudioDatei',
    },
    {
        mimeTyp: 'audio/x-pn-realaudio',
        fileExtension: '*.ram *.ra',
        description: 'RealAudio-Datei',
    },
    {
        mimeTyp: 'audio/x-pn-realaudio-plugin',
        fileExtension: '*.rpm',
        description: 'RealAudio-Plugin-Datei',
    },
    {
        mimeTyp: 'audio/x-qt-stream',
        fileExtension: '*.stream',
        description: 'Quicktime-Streaming-Datei',
    },
    {
        mimeTyp: 'drawing/x-dwf',
        fileExtension: '*.dwf',
        description: 'Drawing-Datei',
    },
    {
        mimeTyp: 'image/bmp',
        fileExtension: '*.bmp',
        description: 'Windows Bitmap-Datei',
    },
    {
        mimeTyp: 'image/x-bmp',
        fileExtension: '*.bmp',
        description: 'Windows Bitmap-Datei',
    },
    {
        mimeTyp: 'image/x-ms-bmp',
        fileExtension: '*.bmp',
        description: 'Windows Bitmap-Datei',
    },
    {
        mimeTyp: 'image/cis-cod',
        fileExtension: '*.cod',
        description: 'CIS-Cod-Datei',
    },
    {
        mimeTyp: 'image/cmu-raster',
        fileExtension: '*.ras',
        description: 'CMU-Raster-Datei',
    },
    {
        mimeTyp: 'image/fif',
        fileExtension: '*.fif',
        description: 'FIF-Datei',
    },
    {
        mimeTyp: 'image/gif',
        fileExtension: '*.gif',
        description: 'GIF-Datei',
    },
    {
        mimeTyp: 'image/ief',
        fileExtension: '*.ief',
        description: 'IEF-Datei',
    },
    {
        mimeTyp: 'image/jpeg',
        fileExtension: '*.jpeg *.jpg *.jpe',
        description: 'JPEG-Datei',
    },
    {
        mimeTyp: 'image/png',
        fileExtension: '*.png',
        description: 'PNG-Datei',
    },
    {
        mimeTyp: 'image/svg+xml',
        fileExtension: '*.svg',
        description: 'SVG-Datei',
    },
    {
        mimeTyp: 'image/tiff',
        fileExtension: '*.tiff *.tif',
        description: 'TIFF-Datei',
    },
    {
        mimeTyp: 'image/vasa',
        fileExtension: '*.mcf',
        description: 'Vasa-Datei',
    },
    {
        mimeTyp: 'image/vnd.wap.wbmp',
        fileExtension: '*.wbmp',
        description: 'Bitmap-Datei (WAP)',
    },
    {
        mimeTyp: 'image/x-freehand',
        fileExtension: '*.fh4 *.fh5 *.fhc',
        description: 'Freehand-Datei',
    },
    {
        mimeTyp: 'image/x-icon',
        fileExtension: '*.ico',
        description: 'Icon-Datei (z.&nbsp;B. Favoriten-Icons)',
    },
    {
        mimeTyp: 'image/x-portable-anymap',
        fileExtension: '*.pnm',
        description: 'PBM Anymap Datei',
    },
    {
        mimeTyp: 'image/x-portable-bitmap',
        fileExtension: '*.pbm',
        description: 'PBM Bitmap Datei',
    },
    {
        mimeTyp: 'image/x-portable-graymap',
        fileExtension: '*.pgm',
        description: 'PBM Graymap Datei',
    },
    {
        mimeTyp: 'image/x-portable-pixmap',
        fileExtension: '*.ppm',
        description: 'PBM Pixmap Datei',
    },
    {
        mimeTyp: 'image/x-rgb',
        fileExtension: '*.rgb',
        description: 'RGB-Datei',
    },
    {
        mimeTyp: 'image/x-windowdump',
        fileExtension: '*.xwd',
        description: 'X-Windows Dump',
    },
    {
        mimeTyp: 'image/x-xbitmap',
        fileExtension: '*.xbm',
        description: 'XBM-Datei',
    },
    {
        mimeTyp: 'image/x-xpixmap',
        fileExtension: '*.xpm',
        description: 'XPM-Datei',
    },
    {
        mimeTyp: 'message/external-body',
        fileExtension: '&nbsp;',
        description: 'Nachricht mit externem Inhalt',
    },
    {
        mimeTyp: 'message/http',
        fileExtension: '&nbsp;',
        description: 'HTTP-Headernachricht',
    },
    {
        mimeTyp: 'message/news',
        fileExtension: '&nbsp;',
        description: 'Newsgroup-Nachricht',
    },
    {
        mimeTyp: 'message/partial',
        fileExtension: '&nbsp;',
        description: 'Nachricht mit Teilinhalt',
    },
    {
        mimeTyp: 'message/rfc822',
        fileExtension: '&nbsp;',
        description: 'Nachricht nach RFC (2)822',
    },
    {
        mimeTyp: 'model/vrml',
        fileExtension: '*.wrl',
        description: 'Visualisierung virtueller Welten (VRML)',
    },
    {
        mimeTyp: 'multipart/alternative',
        fileExtension: '&nbsp;',
        description: 'mehrteilige Daten; jeder Teil ist eine zu den anderen gleichwertige Alternative',
    },
    {
        mimeTyp: 'multipart/byteranges',
        fileExtension: '&nbsp;',
        description: 'mehrteilige Daten mit Byte-Angaben',
    },
    {
        mimeTyp: 'multipart/digest',
        fileExtension: '&nbsp;',
        description: 'mehrteilige Daten / Auswahl',
    },
    {
        mimeTyp: 'multipart/encrypted',
        fileExtension: '&nbsp;',
        description: 'mehrteilige Daten verschlüsselt',
    },
    {
        mimeTyp: 'multipart/form-data',
        fileExtension: '&nbsp;',
        description: 'mehrteilige Daten aus HTML-Formular (z.&nbsp;B. File-Upload)',
    },
    {
        mimeTyp: 'multipart/mixed',
        fileExtension: '&nbsp;',
        description: 'mehrteilige Daten ohne Bezug der Teile untereinander',
    },
    {
        mimeTyp: 'multipart/parallel',
        fileExtension: '&nbsp;',
        description: 'mehrteilige Daten parallel',
    },
    {
        mimeTyp: 'multipart/related',
        fileExtension: '&nbsp;',
        description: 'mehrteilige Daten mit Abhängigkeiten der Teile voneinander',
    },
    {
        mimeTyp: 'multipart/report',
        fileExtension: '&nbsp;',
        description: 'mehrteilige Daten / Bericht',
    },
    {
        mimeTyp: 'multipart/signed',
        fileExtension: '&nbsp;',
        description: 'mehrteilige Daten / bezeichnet',
    },
    {
        mimeTyp: 'multipart/voice-message',
        fileExtension: '&nbsp;',
        description: 'mehrteilige Daten / Sprachnachricht',
    },
    {
        mimeTyp: 'text/calendar',
        fileExtension: '*.ics',
        description: 'iCalendar-Datei',
    },
    {
        mimeTyp: 'text/comma-separated-values',
        fileExtension: '*.csv',
        description: 'kommaseparierte DatenDatei',
    },
    {
        mimeTyp: 'text/css',
        fileExtension: '*.css',
        description: 'CSS Stylesheet-Datei',
    },
    {
        mimeTyp: 'text/html',
        fileExtension: '*.htm *.html *.shtml',
        description: 'HTML-Datei',
    },
    {
        mimeTyp: 'text/javascript',
        fileExtension: '*.js',
        description: 'JavaScript-Datei',
    },
    {
        mimeTyp: 'text/plain',
        fileExtension: '*.txt',
        description: 'reine TextDatei',
    },
    {
        mimeTyp: 'text/richtext',
        fileExtension: '*.rtx',
        description: 'Richtext-Datei',
    },
    {
        mimeTyp: 'text/rtf',
        fileExtension: '*.rtf',
        description: 'RTF-Datei',
    },
    {
        mimeTyp: 'text/tab-separated-values',
        fileExtension: '*.tsv',
        description: 'tabulator-separierte DatenDatei',
    },
    {
        mimeTyp: 'text/vnd.wap.wml',
        fileExtension: '*.wml',
        description: 'WML-Datei (WAP)',
    },
    {
        mimeTyp: 'application/vnd.wap.wmlc',
        fileExtension: '*.wmlc',
        description: 'WMLC-Datei (WAP)',
    },
    {
        mimeTyp: 'text/vnd.wap.wmlscript',
        fileExtension: '*.wmls',
        description: 'WML-ScriptDatei (WAP)',
    },
    {
        mimeTyp: 'application/vnd.wap.wmlscriptc',
        fileExtension: '*.wmlsc',
        description: 'WML-Script-C-Datei (WAP)',
    },
    {
        mimeTyp: 'text/xml',
        fileExtension: '*.xml',
        description: 'XML-Datei',
    },
    {
        mimeTyp: 'text/xml-external-parsed-entity',
        fileExtension: '&nbsp;',
        description: 'extern geparste XML-Datei',
    },
    {
        mimeTyp: 'text/x-setext',
        fileExtension: '*.etx',
        description: 'SeText-Datei',
    },
    {
        mimeTyp: 'text/x-sgml',
        fileExtension: '*.sgm *.sgml',
        description: 'SGML-Datei',
    },
    {
        mimeTyp: 'text/x-speech',
        fileExtension: '*.talk *.spc',
        description: 'Speech-Datei',
    },
    {
        mimeTyp: 'video/mpeg',
        fileExtension: '*.mpeg *.mpg *.mpe',
        description: 'MPEG-VideoDatei',
    },
    {
        mimeTyp: 'video/mp4',
        fileExtension: '*.mp4',
        description: 'MP4-VideoDatei',
    },
    {
        mimeTyp: 'video/ogg',
        fileExtension: '*.ogg *.ogv',
        description: 'OGG-Datei',
    },
    {
        mimeTyp: 'video/quicktime',
        fileExtension: '*.qt *.mov',
        description: 'Quicktime-Datei',
    },
    {
        mimeTyp: 'video/vnd.vivo',
        fileExtension: '*.viv *.vivo',
        description: 'Vivo-Datei',
    },
    {
        mimeTyp: 'video/webm',
        fileExtension: '*.webm',
        description: 'Webm-VideoDatei',
    },
    {
        mimeTyp: 'video/x-msvideo',
        fileExtension: '*.avi',
        description: 'Microsoft AVI-Datei',
    },
    {
        mimeTyp: 'video/x-sgi-movie',
        fileExtension: '*.movie',
        description: 'Movie-Datei',
    },
    {
        mimeTyp: 'video/3gpp',
        fileExtension: '*.3gp',
        description: '3GP Mobile Datei',
    },
    {
        mimeTyp: 'workbook/formulaone',
        fileExtension: '*.vts *.vtts',
        description: 'FormulaOne-Datei',
    },
    {
        mimeTyp: 'x-world/x-3dmf',
        fileExtension: '*=mf *=m *.qd3d *.qd3',
        description: '3DMF-Datei',
    },
    {
        mimeTyp: 'x-world/x-vrml',
        fileExtension: '*.wrl',
        description: 'Visualisierung virtueller Welten (VRML)',
    },
];
export const mimeTypesMap = new Map<string, {fileExtension: string, description: string}>(mimeTypes.map((mime) => [mime.mimeTyp, {fileExtension: mime.fileExtension, description: mime.description}]));
